import Select from 'meinian-package/src/baseComponent/select'
import TiledSelect from 'baseComponent/tiledSelect'
import { PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/enum'

export default (props) => {
  const { value, onChange, placement, ulStyle, trigger } = props
  return <Select
    placement={placement}
    data={[...PLATFORM_CONFIG_ENUM.values()]}
    value={value}
    onChange={onChange}
    placeholder="款式来源"
    style={{ maxHeight: 'unset' }}
    ulStyle={ulStyle}
    trigger={trigger}
  />
}

export const TiledPlatform = ({ value, onChange, style, className }) => {
  return <TiledSelect label="款式来源" options={[...PLATFORM_CONFIG_ENUM.values()]} value={value} onChange={onChange} style={style} className={className} />
}
